import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { Formik, FastField } from 'formik';
import PropTypes from 'prop-types';
import clone from 'lodash/clone';
import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';
import uniqueId from 'lodash/uniqueId';

import LoadMask from 'components/LoadMask';
import BasicButtonGroup from 'components/BasicButtonGroup';
import BasicButton from 'components/BasicButton';
import BasicSubmitButton from 'components/BasicSubmitButton';
import BasicTextArea from 'components/BasicTextArea';
import BasicLabel from 'components/BasicLabel';
import LazyLoadSelect from 'components/LazyLoadSelect';
import BasicInput from 'components/BasicInput';
import RatingStarsWidgetEditable from 'components/RatingStarsWidgetEditable';
import RatingStarsWidget from 'components/RatingStarsWidget';
import DateSelect from 'components/DateSelect';
import BasicSelect from 'components/BasicSelect';
import CreatableValueSelect from 'components/CreatableValueSelect';
import BasicCheckbox from 'components/BasicCheckbox';
import CheckboxOrRadioGroup from 'components/CheckboxOrRadioGroup';
import CreatableLazySelect from 'components/LazyLoadSelect/lazy-load-creatable';
import FormContentLoader from 'components/FormContentLoader';

import { AddReviewInterviewFormValidationSchema } from 'scenes/Form/components/AddReviewInterviewForm/validate';
import { Role } from 'helpers/user';
import { ENDPOINT } from 'constants/endpoints';
import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation.js';
import { get, post } from 'services/api';

import './styles.css';

export const TYPE = {
  RECRUITER: 'recruiter',
  NON_RECRUITER: 'non-recruiter',
};

class AddReviewInterviewForm extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    const isCandidate = Role.isCandidate(props.params.user);
    this._initialValues = {
      isCandidate,
      firm: null,
      type: TYPE.RECRUITER,
      rating: null,
      q1: null, // date
      q2: null, // non-recruiter
      q3: null, // both
      q4: null, // both
      q5: null, // non-recruiter
      q6: null, // non-recruiter
      q7: null, // non-recruiter
      q8: null, // non-recruiter
      q9: null, // non-recruiter
      q10: null, // non-recruiter
      q11: null, // non-recruiter
      q12: null, // non-recruiter
      q13: null, // non-recruiter
      q14: null, // non-recruiter
      q15: null, // both
      q16: null, // both
      q41: null, // recruiter
      q42: null, // recruiter
      q43: null, // recruiter
      q17: null, // both
      q18: null, // non-recruiter
      // checkboxes // non-recruiter
      q19: null,
      q20: null,
      q21: null,
      q22: null,
      q23: null,
      q24: null,
      q25: null,
      q26: null,
      q27: null,
      q28: null,
      //
      q29: null, // non-recruiter
      q30: null, // both
      q31: null, // both
      q32: null, // non-recruiter
      q44: null, // recruiter
      // expected-Compensation-information
      q33: null, // non-recruiter
      q34: null, // non-recruiter
      q35: null, // non-recruiter
      q36: null, // non-recruiter
      q37: null, // non-recruiter
      q38: null, // non-recruiter
      q39: null, // non-recruiter
      q40: null, // non-recruiter
      q45: null, // recruiter

      email: isCandidate ? null : '',
      fullname: isCandidate ? null : '',
      phone: isCandidate ? null : '',
    };

    if (props.params.firm && typeof props.params.firm === 'object') {
      this._initialValues.firm = props.params.firm;
      this._initialValues.type = props.params.firm.type;
      this._initialValues.rating = props.params.firm.rating;
    }

    this.state = {
      init: false,
      selectboxCacheUniq: `_sel_${uniqueId()}`,
    };
  }

  componentWillMount() {
    this._isMounted = true;

    const params =
      this.props.params.firm && typeof this.props.params.firm === 'object'
        ? {}
        : { firm: this.props.params.firm };

    get(ENDPOINT.FORM.GET.REVIEW_INTERVIEW, params, {
      handleSuccess: formData => {
        if (this._isMounted) {
          const data = {
            init: true,
            options: {
              ...formData.options,
            },
            questions: {
              ...formData.questions,
            },
          };

          data.fields = formData.fields
            ? { ...this._initialValues, ...formData.fields }
            : { ...this._initialValues };

          if (data.fields.firm && typeof data.fields.firm === 'object') {
            data.fields.type = data.fields.firm.type;
          }

          this.setState(data);
        }
      },
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.params.user.roles, this.props.params.user.roles)) {
      const isCandidate = Role.isCandidate(this.props.params.user);
      this.setState({
        fields: {
          ...this.state.fields,
          isCandidate,
        },
      });
    }
  }

  handleSubmit = (values, { setSubmitting, setErrors, resetForm }) => {
    const preparedValues = clone(values);

    Object.keys(preparedValues).forEach(field => {
      let data = preparedValues[field];
      if (data === null) {
        delete preparedValues[field];
      } else if (field === 'isCandidate') {
        delete preparedValues[field];
      } else if (field === 'q1') {
        preparedValues['month'] = preparedValues[field].month;
        preparedValues['year'] = preparedValues[field].year;
        delete preparedValues[field];
      } else if (field === 'q45') {
        preparedValues[field] = data.forEach((item, index) => {
          const key = `${field}_${index}`;
          if (item.__isNew__) {
            preparedValues[`${key}Other`] = item.label;
            preparedValues[key] = -2;
          } else {
            preparedValues[key] = item.value;
          }
        });
        delete preparedValues[field];
      } else if (typeof data === 'boolean') {
        preparedValues[field] = data ? 'Yes' : 'No';
      } else if (isArray(data)) {
        preparedValues[field] = data.map(item => {
          return item.id || item.value;
        });
      } else if (typeof data === 'object') {
        preparedValues[field] = data.value;
        if (data.value === -2) {
          preparedValues[`${field}Other`] = data.label;
        }
      }
    });

    post(ENDPOINT.FORM.SAVE.REVIEW_INTERVIEW, preparedValues, {
      handleForbidden: this.handleError,
      handleError: response =>
        this._isMounted
          ? this.props.actions.handleError(response, setErrors)
          : null,
      handleSuccess: () => {
        this.setState({ selectboxCacheUniq: `_sel_${uniqueId()}` });
        resetForm();
        this.props.actions.proceed();
      },
      handleComplete: () => (this._isMounted ? setSubmitting(false) : null),
    });
  };

  getFirmOptions = (query, offset) => {
    return get(ENDPOINT.FORM.OPTIONS.REVIEW.FIRMS, {
      query,
      offset,
      type: 'interview',
    }).then(({ data }) => data);
  };

  getRecFirmOptions = (query, offset) => {
    return get(ENDPOINT.FORM.OPTIONS.REVIEW.FIRMS, {
      query,
      offset,
    }).then(({ data }) => data);
  };

  getLocationOptions = (query, offset) => {
    return get(ENDPOINT.FORM.OPTIONS.REVIEW.LOCATION, {
      query,
      offset,
    }).then(({ data }) => data);
  };

  clearForm = (callback = null) => {
    if (this._isMounted) {
      if (typeof callback === 'function') {
        this.setState(() => ({ fields: { ...this._initialValues } }), callback);
      } else {
        this.setState({ fields: { ...this._initialValues } });
      }
    }
  };

  handleChangeFirm = (field, value, { setFieldValue, resetForm }) => {
    resetForm();
    setFieldValue(field, value);
    setFieldValue('rating', value.rating);
    setFieldValue('type', value.type);
  };

  scrollToError = isValidating => {
    if (
      !isValidating &&
      document.getElementsByClassName('form__error').length > 0
    ) {
      const elem = document.getElementsByClassName('form__error')[0];
      if (elem.previousElementSibling) {
        elem.previousElementSibling.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });
      }
    }
  };

  render() {
    if (!this.state.init) {
      return <FormContentLoader />;
    }

    const {
      fields,
      options: { q2, q3, q3_recruiter, q36, q40, year, answers },
      questions,
    } = this.state;
    return (
      <CSSTransition
        in={true}
        appear={true}
        timeout={ANIMATION_TIMEOUT_APPEAR}
        classNames="fade"
      >
        <div className="form__inner">
          <Formik
            initialValues={fields}
            validationSchema={AddReviewInterviewFormValidationSchema}
            onSubmit={this.handleSubmit}
            onReset={this.clearForm}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleReset,
              isSubmitting,
              isValidating,
              setFieldValue,
              setFieldTouched,
              resetForm,
              submitForm,
            }) => (
              <form
                onSubmit={e => {
                  e.preventDefault();
                  submitForm().then(() => this.scrollToError(isValidating));
                }}
                className="form__content"
              >
                {isSubmitting && <LoadMask />}
                <FastField name="firm">
                  {({ field: { name }, form: { values, errors, touched } }) => (
                    <div className="form__group form__group--compact">
                      <LazyLoadSelect
                        name={name}
                        value={values[name]}
                        isValid={
                          (!errors[name] && !!touched[name]) || !touched[name]
                        }
                        cacheUniq={this.state.selectboxCacheUniq}
                        label="Firm"
                        required
                        placeholder="Start Typing"
                        getOption={this.getFirmOptions}
                        onChange={(field, value) =>
                          this.handleChangeFirm(field, value, {
                            setFieldValue,
                            resetForm,
                          })
                        }
                        onBlur={setFieldTouched}
                      />
                      {errors[name] && !!touched[name] && (
                        <div className="form__error">{errors[name]}</div>
                      )}
                    </div>
                  )}
                </FastField>
                <FastField name="rating">
                  {({ field: { name }, form: { values, errors, touched } }) => (
                    <div className="form__group form__group--compact">
                      <BasicLabel
                        name={name}
                        required
                        text="Your Experience With This Firm"
                      />

                      {values.firm &&
                      values.firm.rating &&
                      values.firm.rating !== '0' ? (
                        <RatingStarsWidget value={values[name]} size={20} />
                      ) : (
                        <RatingStarsWidgetEditable
                          value={values[name] || 0}
                          size={20}
                          onChangeHandler={value => setFieldValue(name, value)}
                        />
                      )}
                      {errors[name] && !!touched[name] && (
                        <div className="form__error">{errors[name]}</div>
                      )}
                    </div>
                  )}
                </FastField>
                <FastField name="q1">
                  {({ field: { name }, form: { values, errors, touched } }) => (
                    <div className="form__group form__group--compact">
                      <DateSelect
                        required
                        label={questions[name]}
                        name={name}
                        controlFunc={setFieldValue}
                        touchFunc={setFieldTouched}
                        values={values[name]}
                        yearOptions={year}
                        isValid={
                          (!errors[name] && !!touched[name]) || !touched[name]
                        }
                      />
                      {errors[name] && !!touched[name] && (
                        <div className="form__error">{errors[name]}</div>
                      )}
                    </div>
                  )}
                </FastField>
                {values.type === TYPE.NON_RECRUITER && (
                  <FastField name="q2">
                    {({
                      field: { name },
                      form: { values, errors, touched },
                    }) => (
                      <div className="form__group form__group--compact">
                        <BasicLabel
                          name={name}
                          required
                          text={questions[name]}
                        />
                        <BasicSelect
                          name={name}
                          value={values[name]}
                          isValid={
                            (!errors[name] && !!touched[name]) || !touched[name]
                          }
                          required
                          placeholder="Select from list..."
                          options={q2}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                        />
                        {errors[name] && !!touched[name] && (
                          <div className="form__error">{errors[name]}</div>
                        )}
                      </div>
                    )}
                  </FastField>
                )}
                <FastField name="q3">
                  {({ field: { name }, form: { values, errors, touched } }) => (
                    <div className="form__group form__group--compact">
                      <CreatableValueSelect
                        name={name}
                        value={values[name]}
                        label={
                          values.type === TYPE.NON_RECRUITER
                            ? 'What position did you interview for?'
                            : 'What types of positions were you targeting?'
                        }
                        isValid={
                          (!errors[name] && !!touched[name]) || !touched[name]
                        }
                        required
                        placeholder="Start Typing"
                        options={
                          values.type === TYPE.NON_RECRUITER ? q3 : q3_recruiter
                        }
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                      />
                      {errors[name] && !!touched[name] && (
                        <div className="form__error">{errors[name]}</div>
                      )}
                    </div>
                  )}
                </FastField>
                <FastField name="q4">
                  {({ field: { name }, form: { values, errors, touched } }) => (
                    <div className="form__group form__group--compact">
                      <LazyLoadSelect
                        name={name}
                        value={values[name]}
                        isValid={
                          (!errors[name] && !!touched[name]) || !touched[name]
                        }
                        label={
                          values.type === TYPE.NON_RECRUITER
                            ? 'In what location was the position?'
                            : 'What locations were you targeting?'
                        }
                        required
                        placeholder="Start Typing"
                        getOption={this.getLocationOptions}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                      />
                      {errors[name] && !!touched[name] && (
                        <div className="form__error">{errors[name]}</div>
                      )}
                    </div>
                  )}
                </FastField>
                {values.type === TYPE.NON_RECRUITER && (
                  <div className="form__group form__group--compact">
                    <BasicLabel
                      name="label"
                      required
                      text="What was your perception of the following when you interviewed"
                    />
                  </div>
                )}

                {values.type === TYPE.NON_RECRUITER &&
                  [
                    'q5',
                    'q6',
                    'q7',
                    'q8',
                    'q9',
                    'q10',
                    'q11',
                    'q12',
                    'q13',
                    'q14',
                  ].map(q => (
                    <FastField name={q} key={q}>
                      {({
                        field: { name },
                        form: { values, errors, touched },
                      }) => (
                        <div className="form__group form__group--compact">
                          <BasicLabel
                            name={name}
                            required
                            text={questions[name]}
                            styles={{
                              textTransform: 'capitalize',
                            }}
                          />
                          <BasicSelect
                            name={name}
                            value={values[name]}
                            isValid={
                              (!errors[name] && !!touched[name]) ||
                              !touched[name]
                            }
                            required
                            placeholder="Select from list..."
                            options={answers}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                          />

                          {errors[name] && !!touched[name] && (
                            <div className="form__error">{errors[name]}</div>
                          )}
                        </div>
                      )}
                    </FastField>
                  ))}

                {['q15', 'q16'].map(q => (
                  <FastField name={q} key={q}>
                    {({
                      field: { name },
                      form: { values, errors, touched },
                    }) => (
                      <div className="form__group form__group--compact">
                        <BasicLabel
                          name={name}
                          required
                          text={questions[name]}
                        />
                        <BasicSelect
                          name={name}
                          value={values[name]}
                          isValid={
                            (!errors[name] && !!touched[name]) || !touched[name]
                          }
                          required
                          placeholder="Select from list..."
                          options={answers}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                        />
                        {errors[name] && !!touched[name] && (
                          <div className="form__error">{errors[name]}</div>
                        )}
                      </div>
                    )}
                  </FastField>
                ))}

                {values.type === TYPE.RECRUITER &&
                  ['q41', 'q42', 'q43'].map(q => (
                    <FastField name={q} key={q}>
                      {({
                        field: { name },
                        form: { values, errors, touched },
                      }) => (
                        <div className="form__group form__group--compact">
                          <BasicLabel
                            name={name}
                            required
                            text={questions[name]}
                          />
                          <BasicSelect
                            name={name}
                            value={values[name]}
                            isValid={
                              (!errors[name] && !!touched[name]) ||
                              !touched[name]
                            }
                            required
                            placeholder="Select from list..."
                            options={answers}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                          />
                          {errors[name] && !!touched[name] && (
                            <div className="form__error">{errors[name]}</div>
                          )}
                        </div>
                      )}
                    </FastField>
                  ))}

                <FastField name="q17">
                  {({ field: { name }, form: { values, errors, touched } }) => (
                    <div className="form__group form__group--compact">
                      <BasicLabel name={name} required text={questions[name]} />
                      <BasicSelect
                        name={name}
                        value={values[name]}
                        isValid={
                          (!errors[name] && !!touched[name]) || !touched[name]
                        }
                        placeholder="Select from list..."
                        options={answers}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                      />
                      {errors[name] && !!touched[name] && (
                        <div className="form__error">{errors[name]}</div>
                      )}
                    </div>
                  )}
                </FastField>

                {values.type === TYPE.NON_RECRUITER && (
                  <>
                    <FastField name="q18">
                      {({
                        field: { name },
                        form: { values, errors, touched },
                      }) => (
                        <div className="form__group form__group--compact">
                          <BasicInput
                            label={questions[name]}
                            required
                            name={name}
                            inputType="number"
                            min={0}
                            content={values[name] || ''}
                            placeholder="Type here..."
                            controlFunc={handleChange}
                            isValid={
                              (!errors[name] && !!touched[name]) ||
                              !touched[name]
                            }
                            touchFunc={handleBlur}
                          />
                          {errors[name] && !!touched[name] && (
                            <div className="form__error">{errors[name]}</div>
                          )}
                        </div>
                      )}
                    </FastField>

                    <div className="form__group form__group--compact">
                      <BasicLabel
                        name="label"
                        required={false}
                        text="Please check all filters used in this process?"
                        styles={{
                          fontWeight: 'bold',
                          marginBottom: '-5px',
                        }}
                      />
                    </div>

                    <div className="form__group form__group--compact">
                      {[
                        'q19',
                        'q20',
                        'q21',
                        'q22',
                        'q23',
                        'q24',
                        'q25',
                        'q26',
                        'q27',
                        'q28',
                      ].map(q => (
                        <FastField name={q} key={q}>
                          {({ field: { name }, form: { values } }) => (
                            <BasicCheckbox
                              key={name}
                              value="Yes"
                              checked={values[name] || false}
                              singleRow={true}
                              title={questions[name]}
                              name={name}
                              controlFunc={handleChange}
                            />
                          )}
                        </FastField>
                      ))}
                    </div>

                    <FastField name="q29">
                      {({ field: { name }, form: { values } }) => (
                        <div className="form__group form__group--compact">
                          <BasicLabel
                            name={name}
                            required={false}
                            text={questions[name]}
                          />
                          <BasicTextArea
                            rows={10}
                            name={name}
                            content={values[name] || ''}
                            resize={false}
                            placeholder="0 characters of the 15000 character limit"
                            controlFunc={handleChange}
                            touchFunc={handleBlur}
                            isValid={
                              (!errors[name] && !!touched[name]) ||
                              !touched[name]
                            }
                          />
                          {errors[name] && !!touched[name] && (
                            <div className="form__error">{errors[name]}</div>
                          )}
                        </div>
                      )}
                    </FastField>
                  </>
                )}

                <FastField name="q30">
                  {({ field: { name }, form: { values } }) => (
                    <div className="form__group form__group--compact">
                      <BasicLabel
                        name={name}
                        required={false}
                        text={questions[name]}
                      />
                      <BasicTextArea
                        rows={10}
                        name={name}
                        content={values[name] || ''}
                        resize={false}
                        placeholder="0 characters of the 15000 character limit"
                        controlFunc={handleChange}
                        touchFunc={handleBlur}
                        isValid={
                          (!errors[name] && !!touched[name]) || !touched[name]
                        }
                      />
                      {errors[name] && !!touched[name] && (
                        <div className="form__error">{errors[name]}</div>
                      )}
                    </div>
                  )}
                </FastField>

                <FastField name="q31">
                  {({ field: { name }, form: { values } }) => (
                    <div className="form__group form__group--compact">
                      <BasicLabel name={name} required text={questions.q31} />
                      <BasicTextArea
                        rows={10}
                        name={name}
                        content={values[name] || ''}
                        resize={false}
                        placeholder="0 characters of the 15000 character limit"
                        controlFunc={handleChange}
                        touchFunc={handleBlur}
                        isValid={
                          (!errors[name] && !!touched[name]) || !touched[name]
                        }
                      />
                      {errors[name] && !!touched[name] && (
                        <div className="form__error">{errors[name]}</div>
                      )}
                    </div>
                  )}
                </FastField>

                {values.type === TYPE.NON_RECRUITER && (
                  <FastField name="q32">
                    {({ field: { name }, form: { values } }) => (
                      <div className="form__group form__group--compact">
                        <BasicLabel
                          name={name}
                          required={false}
                          text={questions[name]}
                        />
                        <BasicTextArea
                          rows={10}
                          name={name}
                          content={values[name] || ''}
                          resize={false}
                          placeholder="0 characters of the 15000 character limit"
                          controlFunc={handleChange}
                          touchFunc={handleBlur}
                          isValid={
                            (!errors[name] && !!touched[name]) || !touched[name]
                          }
                        />
                        {errors[name] && !!touched[name] && (
                          <div className="form__error">{errors[name]}</div>
                        )}
                      </div>
                    )}
                  </FastField>
                )}

                {values.type === TYPE.RECRUITER && (
                  <FastField name="q44">
                    {({ field: { name }, form: { values } }) => (
                      <div className="form__group form__group--compact">
                        <BasicLabel
                          name={name}
                          required={false}
                          text={questions[name]}
                        />
                        <BasicTextArea
                          rows={10}
                          name={name}
                          content={values[name] || ''}
                          resize={false}
                          placeholder="0 characters of the 15000 character limit"
                          controlFunc={handleChange}
                          touchFunc={handleBlur}
                          isValid={
                            (!errors[name] && !!touched[name]) || !touched[name]
                          }
                        />
                        {errors[name] && !!touched[name] && (
                          <div className="form__error">{errors[name]}</div>
                        )}
                      </div>
                    )}
                  </FastField>
                )}

                {values.type === TYPE.NON_RECRUITER && (
                  <>
                    <div className="form__group form__group--compact">
                      <BasicLabel
                        name="expected-Compensation-information"
                        required
                        text="Expected Compensation Information"
                        styles={{
                          fontWeight: 'bold',
                          marginBottom: '-5px',
                        }}
                      />
                    </div>
                    {['q33', 'q34', 'q35'].map(q => (
                      <FastField name={q} key={q}>
                        {({ field: { name }, form: { values } }) => (
                          <div className="form__group form__group--compact">
                            <BasicInput
                              label={questions[name]}
                              labelStyles={{
                                textTransform: 'capitalize',
                              }}
                              required
                              name={name}
                              inputType="number"
                              min={0}
                              content={values[name] || ''}
                              placeholder="Type here..."
                              controlFunc={handleChange}
                              isValid={
                                (!errors[name] && !!touched[name]) ||
                                !touched[name]
                              }
                              touchFunc={handleBlur}
                            />
                            {errors[name] && !!touched[name] && (
                              <div className="form__error">{errors[name]}</div>
                            )}
                          </div>
                        )}
                      </FastField>
                    ))}
                    <FastField name="q36">
                      {({ field: { name }, form: { values } }) => (
                        <div className="form__group form__group--compact">
                          <BasicLabel
                            name={name}
                            required
                            text={questions[name]}
                            styles={{
                              textTransform: 'capitalize',
                            }}
                          />
                          <BasicSelect
                            name={name}
                            value={values[name]}
                            isValid={
                              (!errors[name] && !!touched[name]) ||
                              !touched[name]
                            }
                            placeholder="Select from list..."
                            options={q36}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                          />
                          {errors[name] && !!touched[name] && (
                            <div className="form__error">{errors[name]}</div>
                          )}
                        </div>
                      )}
                    </FastField>
                    <FastField name="q37">
                      {({ field: { name }, form: { values } }) => (
                        <div className="form__group form__group--compact">
                          <BasicInput
                            label={questions[name]}
                            labelStyles={{
                              textTransform: 'capitalize',
                            }}
                            required
                            name={name}
                            inputType="number"
                            min={0}
                            content={values[name] || ''}
                            placeholder="Type here..."
                            controlFunc={handleChange}
                            isValid={
                              (!errors[name] && !!touched[name]) ||
                              !touched[name]
                            }
                            touchFunc={handleBlur}
                          />
                          {errors[name] && !!touched[name] && (
                            <div className="form__error">{errors[name]}</div>
                          )}
                        </div>
                      )}
                    </FastField>
                    <FastField name="q38">
                      {({ field: { name }, form: { values } }) => (
                        <div className="form__group form__group--compact">
                          <BasicLabel
                            name={name}
                            required={false}
                            text={questions[name]}
                          />
                          <BasicTextArea
                            rows={10}
                            name={name}
                            content={values[name] || ''}
                            resize={false}
                            placeholder="0 characters of the 15000 character limit"
                            controlFunc={handleChange}
                            touchFunc={handleBlur}
                            isValid={
                              (!errors[name] && !!touched[name]) ||
                              !touched[name]
                            }
                          />
                          {errors[name] && !!touched[name] && (
                            <div className="form__error">{errors[name]}</div>
                          )}
                        </div>
                      )}
                    </FastField>
                    <FastField name="q39">
                      {({ field: { name }, form: { values } }) => (
                        <div className="form__group form__group--compact">
                          <BasicLabel
                            name={name}
                            required={true}
                            text={questions[name]}
                          />
                          <CheckboxOrRadioGroup
                            name={name}
                            type="radio"
                            options={['Yes', 'No']}
                            selectedOptions={values[name] || ''}
                            directionRow={true}
                            controlFunc={handleChange}
                          />
                          {errors[name] && !!touched[name] && (
                            <div className="form__error">{errors[name]}</div>
                          )}
                        </div>
                      )}
                    </FastField>
                    {values.q39 && values.q39 === 'Yes' && (
                      <FastField name="q40">
                        {({ field: { name }, form: { values } }) => (
                          <div className="form__group form__group--compact">
                            <CreatableValueSelect
                              name={name}
                              value={values[name]}
                              label={questions[name]}
                              isValid={
                                (!errors[name] && !!touched[name]) ||
                                !touched[name]
                              }
                              required
                              placeholder="Start Typing"
                              options={q40}
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                            />
                            {errors[name] && !!touched[name] && (
                              <div className="form__error">{errors[name]}</div>
                            )}
                          </div>
                        )}
                      </FastField>
                    )}
                  </>
                )}

                {values.type === TYPE.RECRUITER && (
                  <FastField name="q45">
                    {({ field: { name }, form: { values } }) => (
                      <div className="form__group form__group--compact">
                        <CreatableLazySelect
                          name={name}
                          isMulti
                          value={values[name]}
                          isValid={
                            (!errors[name] && !!touched[name]) || !touched[name]
                          }
                          label={questions[name]}
                          required
                          placeholder="Start Typing"
                          getOption={this.getRecFirmOptions}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                        />
                        {errors[name] && !!touched[name] && (
                          <div className="form__error">{errors[name]}</div>
                        )}
                      </div>
                    )}
                  </FastField>
                )}

                {!values.isCandidate && (
                  <>
                    <FastField name="email">
                      {({ field: { name }, form: { values, errors } }) => (
                        <>
                          <div className="form__group form__group--compact">
                            <BasicLabel
                              name="label"
                              required
                              text="Contact Information"
                            />
                            <div className="form__sublabel-text">
                              We will keep this confidential and it will not be
                              published but it will allow us to reach out should
                              we have any follow-up questions about the
                              information provided.
                            </div>
                          </div>

                          <div className="form__group form__group--compact">
                            <BasicInput
                              label="Email"
                              required
                              name={name}
                              inputType="email"
                              content={values[name]}
                              placeholder="Type here..."
                              controlFunc={handleChange}
                              isValid={
                                (!errors[name] && !!touched[name]) ||
                                !touched[name]
                              }
                              touchFunc={handleBlur}
                            />
                            {errors[name] && !!touched[name] && (
                              <div className="form__error">{errors[name]}</div>
                            )}
                          </div>
                        </>
                      )}
                    </FastField>

                    <FastField name="fullname">
                      {({ field: { name }, form: { values, errors } }) => (
                        <div className="form__group form__group--compact">
                          <BasicInput
                            label="Full name"
                            required
                            name={name}
                            content={values[name]}
                            placeholder="Type here..."
                            controlFunc={handleChange}
                            isValid={
                              (!errors[name] && !!touched[name]) ||
                              !touched[name]
                            }
                            touchFunc={handleBlur}
                          />
                          {errors[name] && !!touched[name] && (
                            <div className="form__error">{errors[name]}</div>
                          )}
                        </div>
                      )}
                    </FastField>

                    <FastField name="phone">
                      {({ field: { name }, form: { values, errors } }) => (
                        <div className="form__group form__group--compact">
                          <BasicInput
                            label="Phone number"
                            required
                            name={name}
                            content={values[name]}
                            placeholder="Type here..."
                            controlFunc={handleChange}
                            isValid={
                              (!errors[name] && !!touched[name]) ||
                              !touched[name]
                            }
                            touchFunc={handleBlur}
                          />
                          {errors[name] && !!touched[name] && (
                            <div className="form__error">{errors[name]}</div>
                          )}
                        </div>
                      )}
                    </FastField>
                  </>
                )}

                <div className="form__controls form__controls--compact">
                  <BasicButtonGroup>
                    <BasicSubmitButton
                      btnWidth={200}
                      btnHeight={40}
                      btnFontWeight={500}
                      btnArrow={true}
                      btnTextColor="#27282d"
                      btnText="Submit"
                    />

                    <BasicButton
                      controlFunc={handleReset}
                      btnWidth={200}
                      btnHeight={40}
                      btnFontWeight={500}
                      btnArrow={false}
                      btnTextColor="#27282d"
                      btnText="Clear Form"
                    />
                  </BasicButtonGroup>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </CSSTransition>
    );
  }
}

AddReviewInterviewForm.propTypes = {
  params: PropTypes.shape({
    user: PropTypes.object.isRequired,
  }).isRequired,

  actions: PropTypes.shape({
    handleError: PropTypes.func.isRequired,
  }).isRequired,
};

export default AddReviewInterviewForm;
